import React, { useMemo, useState } from 'react';
import { Card, Col, Row, Tab, Nav, Button } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';

const CommunicatinLog = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [showViewModal, setViewShowModal] = useState(false);
    const [communicatinLog, SetCommunicatinLog] = useState([
        {
            id: 1,
            timestam: "2024-01-15T10:30:00Z",
            from: "customer@example.com",
            to: "support@company.com",
            subject: "Login Issue",
            message: "Unable to access my account",
            status: "responded"
        },

    ]);

    const columns = useMemo(
        () => [
            {
                Header: "Org. Name",
                accessor: "orgName",
            },
            {
                Header: "Org. Type",
                accessor: "orgType",
            },
            {
                Header: "Follow-up Date",
                accessor: "followupDate",
            },
            {
                Header: "Follow-up By",
                accessor: "followupBy",
            },
            {
                Header: "Stage",
                accessor: "stage",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const data = useMemo(
        () => [
            {
                id: 1,
                orgName: 'Ab Capital',
                orgType: 'CP',
                followupDate: '01/01/2026',
                followupBy: 'AB Gupta',
                stage: 'Hot',
            },
            {
                id: 2,
                orgName: 'Ab Capital',
                orgType: 'Client',
                followupDate: '02/01/2026',
                followupBy: 'AB Gupta',
                stage: 'Potential Customer',
            },
            {
                id: 3,
                orgName: 'Ab Capital',
                orgType: 'Associate Partner',
                followupDate: '02/01/2026',
                followupBy: 'AB Gupta',
                stage: 'Active',
            },
        ],
        []
    );

    const Pcolumns = useMemo(
        () => [
            {
                Header: "Org. Name",
                accessor: "orgName",
            },
            {
                Header: "Org. Type",
                accessor: "orgType",
            },
            {
                Header: "Last Communicatin Date",
                accessor: "lastCDate",
            },
            {
                Header: "Follow-up By",
                accessor: "followupBy",
            },
            {
                Header: "Stage",
                accessor: "stage",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const Pdata = useMemo(
        () => [
            {
                id: 1,
                orgName: 'Ab Capital',
                orgType: 'CP',
                lastCDate: '01/01/2026',
                followupBy: 'AB Gupta',
                stage: 'Hot',
            },
            {
                id: 2,
                orgName: 'Ab Capital',
                orgType: 'Client',
                lastCDate: '02/01/2026',
                followupBy: 'AB Gupta',
                stage: 'Potential Customer',
            },
            {
                id: 3,
                orgName: 'Ab Capital',
                orgType: 'Associate Partner',
                lastCDate: '02/01/2026',
                followupBy: 'AB Gupta',
                stage: 'Active',
            },
        ],
        []
    );

    const actions = []
    const subActions = ['view']

    const handleView = (rowData) => {

    };


    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Communicatin Log" active="Communicatin Log" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Header className='text-right'>
                                    <div className='aaaa w-100 d-flex'>

                                    </div>
                                </Card.Header>
                                <Card.Body className="example1-table notAddnew">
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="FollowUps">
                                        <Nav variant="pills" className='product-sale'>
                                            <Nav.Item>
                                                <Nav.Link eventKey="FollowUps" className="text-dark">Follow-Ups</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="PastCommunication" className="text-dark">Past Communication</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="FollowUps">
                                                <Tables
                                                    columns={columns}
                                                    data={data}
                                                    actions={actions}
                                                    subActions={subActions}
                                                    onViewLog={handleView}
                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="PastCommunication">
                                                <Tables
                                                    columns={Pcolumns}
                                                    data={Pdata}
                                                    actions={[actions]}
                                                    subActions={subActions}
                                                    onViewLog={handleView}
                                                />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }



            <Modals
                show={showViewModal}
                handleClose={() => setViewShowModal(false)}
                title="View Communicatin Log"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
            >
                <div className='addressCardsbox'>
                    <Row>
                        {communicatinLog.map((item, index) => (
                            <Col md={4}>
                                <div className='addressCard'>
                                    <h4>{item?.subject}</h4>
                                    <p>{item?.timestam}</p>
                                    <p>{item?.from} To {item?.to}</p>
                                    <p>{item?.message}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Modals>

            {isLoadings || isLoading && <Loader />}
        </>
    )
}

export default CommunicatinLog